@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field [appearance]='inputService.inputConfig.appearence'>
      <mat-label>{{inputService.computedTitle | translate}}</mat-label>
      @if (inputService.formInputDefinition.remoteOptions && inputService.formInputDefinition.remoteOptions.icon) {
        <mat-icon matPrefix>{{inputService.formInputDefinition.remoteOptions.icon}}</mat-icon>
      }
      <input [required]='inputService.inputConfig.required' [readonly]='inputService.inputConfig.readOnly' class='dataset-search-input' (click)='openSelectionDialog()' matInput readonly type='text' autocomplete="off" [value]='displayValue'>
      @if (loading) {
        <mat-spinner diameter="20" matSuffix></mat-spinner>
      }
      @if (!loading && !inputService.inputConfig.readOnly) {
        <button mat-icon-button matSuffix (click)='openSelectionDialog()'>
          <mat-icon>search</mat-icon>
        </button>
      }
      @if (selectedRecord && !loading && !inputService.inputConfig.readOnly) {
        <button mat-icon-button matSuffix (click)='unselect()'>
          <span class="material-icons">close</span>
        </button>
      }
      @if (!inputService.control.valid && inputService.errorMessage) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}